import { RxReload } from 'react-icons/rx';
import styles from './styles.module.scss';
import { Box, Button } from '@mui/material';

export default function ErrorCard({ onReset, style }: { onReset: () => void; style?: any }) {
  return (
    <Box
      sx={{
        ...style,
      }}
      className={styles.container}
    >
      {!!onReset && (
        <Button
          startIcon={<RxReload className={styles.icon} />}
          onClick={onReset}
          className={styles.button}
        >
          Попробуйте еще раз
        </Button>
      )}
    </Box>
  );
}
